import Modal from "./Modal";
import Popup from "./Popup";
import Button from "../Button";
import Select from "react-select";
import { useParams } from "react-router-dom";
import constants from "../../../src/constants";
import ReportHooks from "../../Hooks/ReportHooks";
import UserReport from "../UserReport/UserReport";
import AlertContext from "../../context/AlertContext";
import RejectBulk from "../Admin/Batch/Users/RejectBulk";
import { Box, IconButton } from "@mui/material";
import Tooltip from "./Tooltip";
import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import UserDetails from "../Admin/Batch/Users/UserDetails";
import { mkConfig, generateCsv, download } from "export-to-csv";
import { emailBody, getDataFromStorage } from "../../../src/util";
import { UserReportContext } from "../../context/UserReportContext";
import useCommonFunctionHooks from "../../Hooks/useCommonFunctionHooks";

import Whatsapp from "../../Svg/Whatsapp";
import InputDropdown from "./InputDropdown";
import UploadSvg from "../../Svg/UploadIconsvg";
import Typography from "@mui/material/Typography";
import UploadGcatFb from "../Admin/Batch/Users/UploadGcatFb";
import RecommendedPopup from "../Admin/Batch/Users/RecommendedPopup";

import {
  useRef,
  useMemo,
  useState,
  useEffect,
  useContext,
  useCallback,
} from "react";

import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

import {
  QueryClient,
  QueryClientProvider,
  useInfiniteQuery,
} from "@tanstack/react-query";

const fetchSize = 10;

const Users = (props) => {
  const Alert = useContext(AlertContext);

  const axios = useAxiosPrivate();
  const useCommonFunctionHks = useCommonFunctionHooks();
  const { capitalizeFirstLetterOfEachWord } = ReportHooks();

  const { id } = useParams();

  const tableContainerRef = useRef(null); //we can get access to the underlying TableContainer element and react to its scroll events
  const rowVirtualizerInstanceRef = useRef(null); //we can get access to the underlying Virtualizer instance and call its scrollToIndex method

  const [sorting, setSorting] = useState([]);
  const [active, setActive] = useState(true);
  const [testData, setTestData] = useState([]);
  const [addUser, setAddUser] = useState(false);
  const [roleNames, setRoleNames] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [batchNames, setBatchNames] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [globalFilter, setGlobalFilter] = useState();
  const [pendingList, setPendingList] = useState([]);
  const [showReject, setShowReject] = useState(false);
  const [rowSelection, setRowSelection] = useState([]);
  const [selectedRole, setSelectedRole] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState([]);
  const [showRecPopup, setShowRecPopup] = useState(false);
  const [userNameClick, setUserNameClick] = useState(false);
  const [showUserFormPopup, setShowUserFormPopup] = useState(false);

  const [hoveredRowId, setHoveredRowId] = useState(null);
  const [mouseHoveronSvg, setMouseHoveronSvg] = useState(0);
  const [hoveredRecordId, setHoveredRecordId] = useState(0);

  const [newUserInput, setNewUserInput] = useState({
    batchid: id,
    role: "learner",
    emailBody: emailBody,
  });


  const ROLE_DISPLAY_NAMES = {
    hr: "TPO",
    client: "HR",
    admin: "Admin",
    parent: "Parent",
    learner: "Learner",
    tutor: "External Trainer",
    creator: "Content Creator",
    trainer: "Internal Trainer",
    super_admin: "Super Admin",
    evaluator: "Evaluator"
  };


  const ROLE_ACTUAL_NAMES = {
    TPO: "hr",
    HR: "client",
    Admin: "admin",
    Parent: "parent",
    Learner: "learner",
    "External Trainer": "tutor",
    "Content Creator": "creator",
    "Internal Trainer": "trainer",
    "Super Admin": "super_admin",
    Evaluator: "evaluator"
  };

  const handleRejectClick = async () => {
    if (selectedUsers.length > 0) {
      let res = await axios.post(
        "node/admin/batch/pendingtests",
        { batchId: Alert.batchDetails.id, users: selectedUsers },
        useCommonFunctionHks.getHeaderDetailsForAxios()
      );

      setTestData(res.data.data.tests);

      let testNames = res.data.data.tests.map((item) => {
        return { label: item.testname, value: item.testid };
      });

      setPendingList(testNames);
      setShowReject(true);
    } else {
      Alert.setShowNotify({
        show: true,
        title: "Warning",
        msg: "No Learners Selected!",
      });
    }
  };

  const handleEdit = (row) => {
    let AllData = data?.pages.flatMap((page) => page.users);

    const user = AllData?.find((user) => user.email === row._valuesCache.email);

    axios
      .get(
        "node/admin/batch/user/" + user?.user_id,
        useCommonFunctionHks.getHeaderDetailsForAxios()
      )
      .then((res) => {
        if (res.data.resultCode === 1000 && res.data.data != null) {
          let topics = res.data.data?.topics
            ? typeof res.data.data?.topics == "string"
              ? JSON.parse(res.data.data?.topics)
              : res.data.data?.topics
            : [];

          let userDetails = { ...res.data.data };

          userDetails.topics = topics;

          Alert.setFromTrainer(
            res.data.data?.role === constants.Roles.creator ||
              res.data.data?.role === constants.Roles.tutor
              ? true
              : false
          );

          Alert.setIsEditTC(true);
          setNewUserInput(userDetails);
          setShowUserFormPopup(true);
        } else {
          Alert.setShowNotify({
            show: true,
            title: "Warning",
            msg: "No User Exists!",
          });
        }
      })
      .catch((error) => {
        useCommonFunctionHks.getCatchBlockDetails(error);
      });
  };

  const onSave = async (companyId) => {
    Alert.setIsLoaded(true);

    try {
      const response = await axios.post(
        "node/admin/shortlisted/candidates",
        { userIds: selectedUsers, batchId: id, companyId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
        Alert.setShowNotify({
          show: true,
          title: "Info",
          msg:
            response.data.msg ??
            `The student${selectedUsers.length > 1 ? "s are" : " is"
            } successfully shortlisted.`,
        });

        setSelectedUsers([]);
        refetch();
        setShowRecPopup(false);
      } else {
        Alert.setShowNotify({
          show: true,
          title: "Error!",
          msg:
            response.data.msg ??
            "Something went wrong. Please try again later or contact support.",
        });
      }
    } catch (error) {
      console.error("Error fetching companies:", error);

      Alert.setShowNotify({
        show: true,
        title: error.message.includes("403") ? "Warning!" : "Error!",
        msg: error.message.includes("403")
          ? "You have been logged-out due to inactivity. Login again."
          : error.message ??
          "Something went wrong. Please try again later or contact gradious team.",
        isUnAuth: error.message.includes("403"),
      });
    } finally {
      Alert.setIsLoaded(false);
    }
  };

  const columns = [
    {
      accessorFn: (row) => [
        `${capitalizeFirstLetterOfEachWord(
          row?.firstname + " " + row?.lastname
        )}`,
        row?.shortlistedcandidateid,
      ], //accessorFn used to join multiple data into a single cell
      size: 120,
      id: "name", //id is still required when using accessorFn instead of accessorKey
      header: "Name",
      Cell: ({ cell }) => (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <p style={{ margin: 0 }}>{cell.getValue()[0]}</p>
          {cell.getValue()[1] && (
            <Tooltip title="Recommended for Clients" isIcon={true}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                  fill="#12B76A"
                />
                <path
                  d="M10.5795 15.5806C10.3795 15.5806 10.1895 15.5006 10.0495 15.3606L7.21945 12.5306C6.92945 12.2406 6.92945 11.7606 7.21945 11.4706C7.50945 11.1806 7.98945 11.1806 8.27945 11.4706L10.5795 13.7706L15.7195 8.63059C16.0095 8.34059 16.4895 8.34059 16.7795 8.63059C17.0695 8.92059 17.0695 9.40059 16.7795 9.69059L11.1095 15.3606C10.9695 15.5006 10.7795 15.5806 10.5795 15.5806Z"
                  fill="white"
                />
              </svg>
            </Tooltip>
          )}
        </div>
      ),
    },
    {
      size: 150,
      grow: true,
      accessorKey: "email",
      header: "Email Address",
      enableClickToCopy: true,
    },
    {
      size: 75,
      header: "College",
      accessorKey: "college",
    },
    {
      size: 200,
      header: "Batch",
      accessorKey: "branch",
      Cell: ({ cell, row }) => {
        const branchValue = cell.getValue();
        const [hoveredBatch, setHoveredBatch] = useState(null);
        const isLearner = row.original.role === constants.Roles.learner;
        if (typeof branchValue !== "string") {
          return null;
        }
        if (!branchValue.trim()) {
          return <div>-</div>;
        }
        const branches = branchValue.split(/\s*,\s*/);

        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            {branches.map((batch, index) => (
              <span key={`${batch}-${index}`}
                style={{
                  cursor: isLearner ? 'pointer' : 'default',
                  textDecoration: isLearner && hoveredBatch === index ? 'underline' : 'none',
                  color: hoveredBatch === index ? '#f96343' : 'inherit',
                  fontWeight: isLearner && hoveredBatch === index ? "bold" : 'inherit',
                }}
                onMouseEnter={() => isLearner && setHoveredBatch(index)}
                onMouseLeave={() => isLearner && setHoveredBatch(null)}
                onClick={() => {
                  if (isLearner) {
                    // Navigate to the batch only for learner role
                    Alert.navigate(`/batches/${batch.split("-")[0]}/users`, { replace: true });
                  }
                }}
              >{batch.includes("-") ? batch.split("-").slice(1).join("-") : ""}</span>
            ))}
          </div>
        );
      },
    },
    {
      size: 60,
      header: "Role",
      accessorKey: "role",
      Cell: ({ cell }) => {
        const roleValue = cell.getValue();
        return ROLE_DISPLAY_NAMES[roleValue];
      },
    },
    {
      size: 100,
      accessorKey: "mobile",
      header: "Phone Number",
      // Cell: ({ cell }) =>
      //   cell.getValue() !== "" &&
      //   cell.getValue() !== undefined &&
      // cell.getValue().length >= 10 &&
      //    (
      //
      // <>
      //   <Typography component="div">
      //     <Whatsapp />
      //   </Typography>{" "}
      //   <a
      //     target="_blank"
      //     rel="noopener noreferrer"
      //     href={`https://wa.me/${cell.getValue()}`}
      //   >
      // {cell.getValue()}
      //   </a>
      // </>
      // ),
      enableClickToCopy: true,
    },
    // {
    //   size: 100,
    //   id: "completedtests",
    //   header: "Completed Tests",
    //   accessorFn: (row) =>
    //     `${row.completedtests == null || row.completedtests == undefined
    //       ? 0
    //       : row.completedtests
    //     }/${row.totaltests}`,
    //   muiTableHeadCellProps: {
    //     align: "center",
    //   },
    //   muiTableBodyCellProps: {
    //     align: "center",
    //   },
    // },
    // {
    //   size: 180,
    //   header: "Batches",
    //   accessorKey: "lastsubmittedtest",
    // },
  ];

  const resetTableState = useCallback(() => {
    queryClient.removeQueries({
      queryKey: ["users-table"],
      exact: false,
    });

    setSorting([]);
    setGlobalFilter("");
    setSelectedBatch([]);
    setSelectedRole([]);
    setSelectedUsers([]);
    setTotalUsers(0);
    setBatchNames([]);
    setRoleNames([]);

    refetch();
  }, [id, active]);

  const { data, fetchNextPage, isError, isFetching, isLoading, refetch } =
    useInfiniteQuery({
      queryKey: [
        "users-table",
        id,
        active,
        sorting,
        globalFilter,
        selectedBatch,
        selectedRole,
      ],
      queryFn: async ({ pageParam = 0 }) => {
        const endPoint = "node/admin/userreport";

        try {
          const batchFilter = selectedBatch.length > 0
            ? selectedBatch.map(batch => batch.value)
            : [];


          const roleFilter = selectedRole.length > 0
            ? selectedRole.map(role => ROLE_ACTUAL_NAMES[role.label] || role.value)
            : ["all"];
          const response = await axios.post(
            endPoint,
            { batchId: id, status: active, batches: batchFilter, role: roleFilter },
            {
              params: {
                size: fetchSize,
                start: pageParam * fetchSize,
                globalFilter: globalFilter ?? "",
                sorting: JSON.stringify(sorting ?? []),
                batches: JSON.stringify(batchFilter),
                role: JSON.stringify(roleFilter),
              },
              headers: { "Content-type": "application/json" },
            }
          );

          if (addUser) {
            setAddUser(false);
          }

          let data = response.data.data ?? [];


          setBatchNames(
            data.batches.map((item) => ({
              value: item.batchId,
              label: item.batchName,
            }))
          );

          setRoleNames(
            data.roles.map((item) => ({
              value: item.roleid,
              label: ROLE_DISPLAY_NAMES[item.role],
            }))
          );


          setTotalUsers(data.userCount[0].total_users);

          return data;
        } catch (error) {
          useCommonFunctionHks.getCatchBlockDetails(error);
          throw error;
        }
      },
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      initialPageParam: 0,
      // refetchOnMount: true,
      // refetchOnWindowFocus: false,
      getNextPageParam: (_lastGroup, groups) => groups.length,
      // getNextPageParam: (lastPage, allPages) => {
      //   const totalFetched = allPages.flatMap((page) => page.users).length;
      //   return totalFetched < lastPage.userCount[0]?.total_users
      //     ? allPages.length
      //     : undefined;
      // },
    });

  // useEffect(() => {
  //   setSelectedBatch([]);
  //   setSelectedRole([]);
  //   setGlobalFilter(undefined);
  //   setSorting([]);
  //   setSelectedUsers([]);
  //   setTotalUsers(0);
  //   queryClient.removeQueries({
  //     queryKey: [sorting, "table-data", globalFilter, selectedBatch]
  //   });
  //   refetch();
  // }, [id]);

  useEffect(() => {
    resetTableState();
  }, [id, active, resetTableState]);

  useEffect(() => {
    if (selectedBatch || selectedRole) {
      refetch();
    }
  }, [selectedBatch, selectedRole, refetch]);

  useEffect(() => {
    try {
      refetch();
    } catch (error) {
      useCommonFunctionHks.getCatchBlockDetails(error);
    }
  }, [active, refetch]);

  const flatData = useMemo(() => {
    return data?.pages.flatMap((page) => page?.users) ?? [];
  }, [data]);

  const totalDBRowCount = data?.pages[0]?.totalUsercount;

  const totalFetched = flatData?.length;
  const handleSelectAll = (e) => {
    e.stopPropagation();

    let AllData = data?.pages.flatMap((page) => page.users);
    let allUserIds = AllData.map((user) => user.userId);

    if (selectedUsers.length === allUserIds.length) {
      setSelectedUsers([]);
    } else {
      setSelectedUsers(allUserIds);
    }
  };

  const handleSelect = (e, row) => {
    e.stopPropagation();

    let AllData = data?.pages.flatMap((page) => page.users);

    const user = AllData?.find((user) => user.email === row._valuesCache.email);

    let newLearnerids = [];
    let learnerids = [...selectedUsers];

    if (learnerids.length > 0 && learnerids.includes(user.userId)) {
      newLearnerids = learnerids.filter((item) => item !== user.userId);
    } else {
      newLearnerids = [...selectedUsers, user.userId];
    }

    setSelectedUsers(newLearnerids);
  };

  const fetchMoreOnBottomReached = useCallback(
    (containerRefElement) => {
      if (containerRefElement) {
        const { scrollHeight, scrollTop, clientHeight } = containerRefElement;
        if (scrollHeight - scrollTop - clientHeight < 400 && !isFetching) {
          fetchNextPage();
        }
      }
    },
    [fetchNextPage, isFetching, totalFetched, totalDBRowCount]
  );

  const csvConfig = mkConfig({
    fieldSeparator: ",",
    decimalSeparator: ".",
    useKeysAsHeaders: true,
    filename: `${Alert.batchDetails.name}`,
  });

  const onCloseRecPopup = () => {
    setSelectedUsers([]);
    setShowRecPopup(false);
  };

  const table = useMaterialReactTable({
    columns,
    data: flatData,
    enableRowActions: true,
    renderRowActions: ({ row }) => (
      <Box
        sx={{ display: "flex", flexWrap: "nowrap", gap: "0px", ml: "-10px" }}
      >
        {Alert.isAdmin &&
          getDataFromStorage("role") !== constants.Roles.tutor && (
            <Tooltip title="Edit" isIcon={true}>
              <IconButton color="error" onClick={() => handleEdit(row)}>
                <svg
                  width="16"
                  height="16"
                  fill="none"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                  className="editIconUserPage"
                >
                  <g clip-path="url(#clip0_6374_11614)">
                    <path
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M9.1665 3.33333H3.33317C2.89114 3.33333 2.46722 3.50893 2.15466 3.82149C1.8421 4.13405 1.6665 4.55797 1.6665 5V16.6667C1.6665 17.1087 1.8421 17.5326 2.15466 17.8452C2.46722 18.1577 2.89114 18.3333 3.33317 18.3333H14.9998C15.4419 18.3333 15.8658 18.1577 16.1783 17.8452C16.4909 17.5326 16.6665 17.1087 16.6665 16.6667V10.8333M15.4165 2.08333C15.748 1.75181 16.1977 1.56557 16.6665 1.56557C17.1353 1.56557 17.585 1.75181 17.9165 2.08333C18.248 2.41485 18.4343 2.86449 18.4343 3.33333C18.4343 3.80217 18.248 4.25181 17.9165 4.58333L9.99984 12.5L6.6665 13.3333L7.49984 10L15.4165 2.08333Z"
                      stroke={"#344054"}
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_6374_11614">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </IconButton>
            </Tooltip>
          )}
      </Box>
    ),

    muiTableHeadCellProps: {
      sx: {
        '& .MuiTableSortLabel-icon': {
          display: 'none',
        },
      },
    },
    initialState: {
      showGlobalFilter: true,
      columnVisibility: { college: false, branch: true, mobile: false },
    },
    manualSorting: true,
    manualFiltering: true,
    enablePagination: false,
    enableStickyFooter: false,
    enableColumnActions: false,
    enableColumnFilters: false,
    positionGlobalFilter: "left",
    positionActionsColumn: "last",
    enableRowVirtualization: true,
    getRowId: (row) => row?.user_id,
    positionToolbarAlertBanner: "none",
    // enableRowNumbers: getDataFromStorage("role") === constants.Roles.admin,
    // enableRowSelection: getDataFromStorage("role") !== constants.Roles.hr,
    // enableMultiRowSelection: getDataFromStorage("role") !== constants.Roles.hr,
    // muiSelectCheckboxProps: ({ row }) => ({
    //   onClick: (e) => {
    //     handleSelect(e, row);
    //   },
    //   rowSelection: false,
    //   defaultChecked: false,
    //   checked:
    //     selectedUsers.includes(row?.id) &&
    //     flatData.map((r) => r?.userId).includes(row?.id),
    //   sx: {
    //     cursor: "pointer", //you might want to change the cursor too when adding an onClick
    //   },
    // }),
    // muiSelectAllCheckboxProps: ({ table }) => ({
    //   rowSelection: false,
    //   defaultChecked: false,
    //   onClick: handleSelectAll,
    //   checked: flatData.map((r) => r?.userId)?.length === selectedUsers.length,
    //   sx: {
    //     cursor: "pointer", //you might want to change the cursor too when adding an onClick
    //   },
    // }),
    muiTableContainerProps: {
      ref: tableContainerRef, //get access to the table container element
      sx: { maxHeight: "600px", paddingBottom: "140px" }, //give the table a max height
      onScroll: (event) => fetchMoreOnBottomReached(event.target), //add an event listener to the table container element
    },
    muiToolbarAlertBannerProps: isError
      ? {
        color: "error",
        children: "Error loading data",
      }
      : undefined,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    onRowSelectionChange: setRowSelection,
    // onColumnFiltersChange: setColumnFilters,
    // onColumnFiltersChange: setSelectedBatch,

    state: {
      sorting,
      isLoading,
      globalFilter,
      rowSelection,
      selectedBatch,
      selectedRole,
      active: active,
      showAlertBanner: isError,
      showProgressBars: isFetching || userNameClick,
    },
    rowVirtualizerInstanceRef, //get access to the virtualizer instance
    rowVirtualizerOptions: { overscan: 4 },
  });

  const handleChangeBatchFilter = (selectedOption) => {
    setSelectedBatch(selectedOption || []);
  };

  const handleChangeRoleFilter = (selectedOption) => {
    setSelectedRole(selectedOption || []);
  };

  // Add proper useEffect to refetch when filters change
  useEffect(() => {
    // Debounce the refetch to avoid too many API calls
    const timeoutId = setTimeout(() => {
      refetch();
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [selectedBatch, selectedRole, refetch]);

  const onAddUser = () => {
    setShowUserFormPopup(true);
    setNewUserInput((prev) => ({
      ...prev,
      role: constants.Roles.creator,
    }));
  };
  return (
    <div className="usersPageComponent">
      <div className="noofuserssection">
        <div className="righttools">
          <p className="userstext"> Users </p>
          <div className="noofuserdiv">
            <p className="noofusers">
              {totalFetched} / {totalUsers}
            </p>
          </div>
        </div>
        <div className="lefttools">
          {/* {getDataFromStorage("role") !== constants.Roles.hr && getDataFromStorage("role") !== constants.Roles.tutor && (
            <>
              <div className="recStudentSec">
                <Button
                  size="sm"
                  hierarchy={{
                    type: "secondaryGrey",
                    buttonText: "Recommend",
                  }}
                  disable={selectedUsers.length === 0}
                  onClick={() => setShowRecPopup(!showRecPopup)}
                />
                {showRecPopup && (
                  <RecommendedPopup
                    onCancel={onCloseRecPopup}
                    onSave={onSave}
                  />
                )}
              </div>
            </>
          )} */}

          <Button
            size="sm"
            hierarchy={{ type: "secondaryGrey", buttonText: "Add User" }}
            icon={{
              icon: (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.0001 4.16666V15.8333M4.16675 10H15.8334"
                    stroke="#344054"
                    strokeWidth="1.67"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ),
              type: "leading",
            }}
            onClick={onAddUser}
          />

          <Select
            className="usersPageDropdown"
            isSearchable={false}
            options={batchNames}
            value={selectedBatch}
            isMulti={true}
            onChange={handleChangeBatchFilter}
            placeholder="Select Batch..."
          />

          <Select
            className="usersPageDropdown"
            isSearchable={false}
            options={roleNames}
            value={selectedRole}
            isMulti={true}
            onChange={handleChangeRoleFilter}
            placeholder="Select Role..."
          />
        </div>
      </div>

      <MaterialReactTable table={table} />
      {Alert.isCommonPopup && !addUser && (
        <div className="popup-overlay">
          <Popup />
        </div>
      )}
      {showReject && (
        <RejectBulk
          testData={testData}
          setShowReject={setShowReject}
          selectedUsers={selectedUsers}
          pendingTestLists={pendingList}
          setSelectedUsers={setSelectedUsers}
        />
      )}
      {showUserFormPopup && (
        <UserDetails
          addUser={addUser}
          refetch={refetch}
          isCCFlow={true}
          setAddUser={setAddUser}
          newUserInput={newUserInput}
          setNewUserInput={setNewUserInput}
          showUserFormPopup={showUserFormPopup}
          setShowUserFormPopup={setShowUserFormPopup}
        />
      )}
      <Modal
        isOpen={showPopup}
        showCloseIcon={true}
        component={"leaderboard"}
        onClose={() => setShowPopup(false)}
      >
        <UserReport />
      </Modal>
    </div>
  );
};

const queryClient = new QueryClient();

const UsersTableQueryProviders = (props) => (
  <QueryClientProvider client={queryClient}>
    <Users {...props} />
  </QueryClientProvider>
);

export default UsersTableQueryProviders;
// const Users = () => {
//   return (
//     // <UsersTableQueryProvider />
//   );
// }

// export default Users;
